<template lang="pug">
  .op-modal
    .op-modal__title
      h2.title Отклонить заявку
    .op-modal__body
      .form
        .form__elem
          .form-elem
            .form-elem__title Укажите причину отказа
            .form-elem__body
              .form-elem-list
                .form-elem-list__item
                  label.input-item
                    .input-item__input
                      .radio
                        input.radio__input(
                        type="radio"
                        name="reason"
                        checked="checked"
                        )
                        .radio__icon
                    .input-item__body
                      .input-item__text Копии документов не подтверждены в срок
                .form-elem-list__item
                  label.input-item
                    .input-item__input
                      label.radio
                        input.radio__input(
                        type="radio"
                        name="reason"
                        )
                        .radio__icon
                    .input-item__body
                      .input-item__text Оплата не выполнена в срок
        .form__elem.form__elem_button
          .form-elem
            .form-elem__body
              button.button.button_paint-secondary.button_long(
              type="submit"
              )
                .button__text Отправить
            .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
</template>

<script>
export default {
  name: "OperatorRejectDocs",
  data() {
    return {
      showErrorInfo: false
    };
  }
};
</script>
